import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type LocaleMode = 'KEY' | 'EN' | 'KO';

interface LocaleStore {
  mode: LocaleMode;
  /**
   * Bumped after `loadTranslations` populates the module-level cache so React
   * components subscribing to the store re-render and pick up the new
   * translations.
   */
  dataVersion: number;
  setMode: (m: LocaleMode) => void;
  bumpDataVersion: () => void;
}

export const useLocaleStore = create<LocaleStore>()(
  persist(
    (set) => ({
      mode: 'KEY',
      dataVersion: 0,
      setMode: (m) => set({ mode: m }),
      bumpDataVersion: () => set((s) => ({ dataVersion: s.dataVersion + 1 })),
    }),
    {
      name: 'master-data-locale-mode',
      partialize: (state) => ({ mode: state.mode }),
    }
  )
);
